<template>
  <b-card no-body>
    <b-card-header>
      <b-card-title>Teklif Geçmişi</b-card-title>
    </b-card-header>
    <b-table
      v-if="details.length > 0"
      responsive="sm"
      :fields="fields"
      :items="details"
      striped
    >
      <template #cell(onumber)="data">
        <div class="d-flex align-content-start align-items-center">
          <div>
            <b-button
              v-b-tooltip.hover.top="'Teklifi Görüntüle'"
              variant="flat-success"
              class="btn-icon rounded-circle"
              :href="'/app/offers/view/' + data.item.id"
              target="_blank"
            >
              <FeatherIcon icon="EyeIcon" />
            </b-button>
          </div>
          <div class="ml-1">
            <div>
              {{ data.item.onumber }}
            </div>
          </div>
        </div>
      </template>
      <template #cell(company)="data">
        <div class="d-flex align-content-start align-items-center">
          <div>
            <div>
              {{ data.item.company }}
            </div>
            <div class="font-small-2">
              <strong class="text-primary">Teklif Tarihi:</strong> {{ moment(data.item.odate).format('DD.MM.YYYY') }}
            </div>
            <div class="font-small-2">
              <strong class="text-primary">Geçerlilik Tarihi:</strong> {{ moment(data.item.vdate).format('DD.MM.YYYY') }}
            </div>
          </div>
        </div>
      </template>
      <template #cell(offer_status)="data">
        <div>
          {{ data.item.offer_status }}
        </div>
        <div class="text-primary font-small-2">
          {{ data.item.username }}
        </div>
      </template>
    </b-table>
    <b-card-body v-else>
      <empty-alert />
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardTitle, BCardBody, BButton, BTable, VBTooltip,
} from 'bootstrap-vue'
import EmptyAlert from '@/views/Admin/Reports/common/EmptyAlert.vue'

export default {
  name: 'Offers',
  components: {
    EmptyAlert,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BTable,
    BButton,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      fields: [
        {
          key: 'onumber',
          label: 'TEKLİF NO',
          thClass: 'text-nowrap',
        },
        {
          key: 'company',
          label: 'FİRMA ADI',
          thClass: 'text-nowrap',
        },
        {
          key: 'offer_status',
          label: 'DURUM',
          thClass: 'text-nowrap',
        },
      ],
    }
  },
  computed: {
    details() {
      return this.$store.getters['customerReports/offers']
    },
  },
  created() {
    this.getReport()
  },
  methods: {
    getReport() {
      this.$store.dispatch('customerReports/getOffers', this.$route.params.id)
    },
  },
}
</script>
